import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './RootErrorBoundary.css';
import { isRouteErrorResponse, useLocation, useRouteError } from 'react-router-dom';
import { useLogger } from '../../../';
function getErrorMessage(error) {
    if (isRouteErrorResponse(error)) {
        return `${error.status} ${error.statusText}`;
    }
    return error instanceof Error ? error.message : JSON.stringify(error);
}
export function RootErrorBoundary() {
    const error = useRouteError();
    const location = useLocation();
    const logger = useLogger();
    logger.error(`[shell] An unmanaged error occured while rendering the route with path ${location.pathname}`, error);
    return (_jsxs("p", { className: "error-message", children: ["An unmanaged error occured insisde a module. Still, other parts of the application are fully functional!", _jsx("br", {}), _jsx("span", { role: "img", "aria-label": "pointer", children: "\uD83D\uDC49" }), getErrorMessage(error)] }));
}
